var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49982 12H21.4998M5.99982 16H9.99982M8.96638 4.00005H15.0332C16.1101 4.00005 16.6485 4.00005 17.1239 4.16401C17.5443 4.30901 17.9272 4.54565 18.2449 4.8568C18.6041 5.20865 18.8449 5.69025 19.3265 6.65342L21.493 10.9865C21.682 11.3645 21.7765 11.5535 21.8432 11.7515C21.9024 11.9275 21.9451 12.1085 21.9708 12.2923C21.9998 12.4992 21.9998 12.7105 21.9998 13.1331V15.2C21.9998 16.8802 21.9998 17.7202 21.6728 18.362C21.3852 18.9265 20.9263 19.3854 20.3618 19.673C19.72 20 18.88 20 17.1998 20H6.79982C5.11966 20 4.27958 20 3.63785 19.673C3.07336 19.3854 2.61442 18.9265 2.3268 18.362C1.99982 17.7202 1.99982 16.8802 1.99982 15.2V13.1331C1.99982 12.7105 1.99982 12.4992 2.02879 12.2923C2.05453 12.1085 2.09726 11.9275 2.15644 11.7515C2.22308 11.5535 2.31758 11.3645 2.50657 10.9865L4.67313 6.65342C5.15472 5.69024 5.39552 5.20865 5.75477 4.8568C6.07245 4.54565 6.45533 4.30901 6.87571 4.16401C7.35107 4.00005 7.88951 4.00005 8.96638 4.00005Z",
    stroke: "#596780",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.90378b8c4043e89987af9fc25d08a42f.svg";
export { ForwardRef as ReactComponent };